<app-toast-container aria-live="polite" aria-atomic="true"></app-toast-container>
<div id="charactersheet" class="charactersheet" *ngIf="!still_loading()">
    <!--Desktop-only views-->
    <div class="charactersheet-app charactersheet-row mobile-hide" id="desktop-tabs" *ngIf="!mobile">
        <button
            [ngClass]="{'fancy-button':get_ShowMode()==='' || !['Encounter','Exploration','Downtime','Inventory','ConditionsEffects'].includes(get_ShowMode())}"
            (click)="toggle_Mode('')">Show All</button>
        <button [ngClass]="{'fancy-button':get_ShowMode()==='Encounter'}"
            (click)="toggle_Mode('Encounter')">Encounter</button>
        <button [ngClass]="{'fancy-button':get_ShowMode()==='Exploration'}"
            (click)="toggle_Mode('Exploration')">Exploration</button>
        <button [ngClass]="{'fancy-button':get_ShowMode()==='Downtime'}"
            (click)="toggle_Mode('Downtime')">Downtime</button>
        <button [ngClass]="{'fancy-button':get_ShowMode()==='Inventory'}"
            (click)="toggle_Mode('Inventory')">Inventory</button>
        <button [ngClass]="{'fancy-button':get_ShowMode()==='ConditionsEffects'}"
            (click)="toggle_Mode('ConditionsEffects')">Conditions & Effects</button>
    </div>
    <ng-container *ngIf="!still_loading() && get_ShowMode() !== 'ConditionsEffects' && !mobile">
        <app-time class="charactersheet-app charactersheet-row mobile-hide" [sheetSide]="'center'"
            [showTurn]="(['','Encounter'].includes(get_ShowMode()))" [showTime]="(get_ShowMode() !== 'Encounter')"
            [ngClass]="{'minimized':(get_TimeMinimized())}"></app-time>
        <app-effects id="Character-effects" class="charactersheet-app charactersheet-row mobile-hide"
            [sheetSide]="'center'">
        </app-effects>
        <div class="charactersheet-column-container mobile-hide">
            <div class="charactersheet-column">
                <app-general id="Character-general" class="charactersheet-app" [sheetSide]="'left'"
                    [ngClass]="{'minimized':(get_GeneralMinimized())}"
                    *ngIf="!['Encounter', 'Inventory'].includes(get_ShowMode())">
                </app-general>
                <app-defense id="Character-defense" class="charactersheet-app" [sheetSide]="'left'"
                    [ngClass]="{'minimized':(get_DefenseMinimized())}" *ngIf="get_ShowMode()==='Encounter'">
                </app-defense>
                <app-health id="Character-health" class="charactersheet-app" [sheetSide]="'left'"
                    [showMinimizeButton]="(get_ShowMode() !== 'Downtime')"
                    [ngClass]="{'minimized':(get_HealthMinimized() || (get_ShowMode() === 'Downtime'))}"
                    *ngIf="get_ShowMode()!=='Inventory'">
                </app-health>
                <app-general id="Character-general" class="charactersheet-app" [sheetSide]="'left'"
                    [ngClass]="{'minimized':(get_GeneralMinimized())}" *ngIf="(get_ShowMode() === 'Encounter')">
                </app-general>
                <app-abilities id="Character-abilities" class="charactersheet-app" [sheetSide]="'left'"
                    [ngClass]="{'minimized':(get_AbilitiesMinimized())}" *ngIf="get_ShowMode()!=='Inventory'">
                </app-abilities>
                <app-skills id="Character-skills" class="charactersheet-app" [sheetSide]="'left'"
                    [ngClass]="{'minimized':(get_SkillsMinimized())}"
                    *ngIf="['', 'Encounter'].includes(get_ShowMode()) || !['Exploration','Downtime','Inventory'].includes(get_ShowMode())">
                </app-skills>
                <app-activities id="Character-activities" class="charactersheet-app" [sheetSide]="'left'"
                    [ngClass]="{'minimized':(get_ActivitiesMinimized())}"
                    *ngIf="['', 'Encounter'].includes(get_ShowMode()) || !['Exploration','Downtime','Inventory'].includes(get_ShowMode())">
                </app-activities>
                <app-spellbook id="spellbook" class="charactersheet-app" [sheetSide]="'left'"
                    [ngClass]="{'minimized':(get_SpellbookMinimized())}" *ngIf="(get_ShowMode() === 'Downtime')">
                </app-spellbook>
                <app-inventory id="Character-inventory" class="charactersheet-app" [sheetSide]="'right'"
                    [ngClass]="{'minimized':(get_InventoryMinimized())}" *ngIf="get_ShowMode()==='Inventory'">
                </app-inventory>
            </div>
            <div class="charactersheet-column">
                <app-defense id="Character-defense" class="charactersheet-app" [sheetSide]="'right'"
                    [ngClass]="{'minimized':(get_DefenseMinimized())}"
                    *ngIf="['', 'Inventory'].includes(get_ShowMode())">
                </app-defense>
                <ng-container *ngFor="let index of [0,1]; trackBy:trackByIndex;">
                    <app-attacks id="Character-attacks" class="charactersheet-app" [sheetSide]="'right'"
                        [ngClass]="{'minimized':(get_AttacksMinimized())}"
                        *ngIf="(['','Encounter','Inventory'].includes(get_ShowMode()) || !['Exploration','Downtime'].includes(get_ShowMode())) && get_ClassOrder('attacks') === index">
                    </app-attacks>
                    <app-spellbook id="spellbook" class="charactersheet-app" [sheetSide]="'right'"
                        [ngClass]="{'minimized':(get_SpellbookMinimized())}"
                        *ngIf="(['','Encounter'].includes(get_ShowMode()) || !['Exploration','Downtime','Inventory'].includes(get_ShowMode())) && get_ClassOrder('spells') === index">
                    </app-spellbook>
                </ng-container>
                <app-skills id="Character-skills" class="charactersheet-app" [sheetSide]="'right'"
                    [ngClass]="{'minimized':(get_SkillsMinimized())}"
                    *ngIf="['Exploration','Downtime','Inventory'].includes(get_ShowMode())"></app-skills>
                <app-activities id="Character-activities" class="charactersheet-app" [sheetSide]="'right'"
                    [ngClass]="{'minimized':(get_ActivitiesMinimized())}"
                    *ngIf="['Exploration','Downtime'].includes(get_ShowMode())">
                </app-activities>
                <app-spellbook id="spellbook" class="charactersheet-app" [sheetSide]="'right'"
                    [ngClass]="{'minimized':(get_SpellbookMinimized())}" *ngIf="(get_ShowMode() === 'Exploration')">
                </app-spellbook>
                <app-inventory id="Character-inventory" class="charactersheet-app" [sheetSide]="'right'"
                    [ngClass]="{'minimized':(get_InventoryMinimized())}" *ngIf="get_ShowMode()===''"></app-inventory>
            </div>
        </div>
    </ng-container>
    <!--Mobile-Only buttons and views-->
    <div class="charactersheet-app charactersheet-row desktop-hide" id="mobile-tabs" *ngIf="mobile">
        <button
            [ngClass]="{'fancy-button':get_ShowMode()==='' || !['Health','Defense','Attacks','Spells','Skills','Actions','Inventory','ConditionsEffects'].includes(get_ShowMode())}"
            (click)="toggle_Mode('')">
            <i class="bi-info-circle-fill"></i>
        </button>
        <button [ngClass]="{'fancy-button':get_ShowMode()==='Health'}" (click)="toggle_Mode('Health')">
            <i class="ra ra-health"></i>
        </button>
        <button [ngClass]="{'fancy-button':get_ShowMode()==='Defense'}" (click)="toggle_Mode('Defense')">
            <i class="ra ra-shield"></i>
        </button>
        <button [ngClass]="{'fancy-button':get_ShowMode()==='Attacks'}" (click)="toggle_Mode('Attacks')">
            <i class="ra ra-sword"></i>
        </button>
        <button [ngClass]="{'fancy-button':get_ShowMode()==='Spells'}" (click)="toggle_Mode('Spells')">
            <i class="ra ra-doubled"></i>
        </button>
        <button [ngClass]="{'fancy-button':get_ShowMode()==='Skills'}" (click)="toggle_Mode('Skills')">
            <i class="ra ra-muscle-up"></i>
        </button>
        <button [ngClass]="{'fancy-button':get_ShowMode()==='Actions'}" (click)="toggle_Mode('Actions')">
            <app-actionIcons [actionString]="'1A'" style="margin:.12rem -.16rem -.14rem -.16rem"></app-actionIcons>
        </button>
        <button [ngClass]="{'fancy-button':get_ShowMode()==='Inventory'}" (click)="toggle_Mode('Inventory')">
            <i class="bi-box"></i>
        </button>
        <button [ngClass]="{'fancy-button':get_ShowMode()==='ConditionsEffects'}"
            (click)="toggle_Mode('ConditionsEffects')">
            <i class="ra ra-lightning-bolt"></i>
            <i class="bi-clock"></i>
        </button>
    </div>
    <ng-container *ngIf="!still_loading() && get_ShowMode() !== 'ConditionsEffects' && mobile">
        <div class="charactersheet-column-container desktop-hide">
            <div class="charactersheet-column">
                <app-general id="Character-general" class="charactersheet-app" [sheetSide]="'center'"
                    [ngClass]="{'minimized':(get_GeneralMinimized())}"
                    *ngIf="!get_ShowMode() || !['Health','Defense','Attacks','Spells','Skills','Actions','Inventory','ConditionsEffects'].includes(get_ShowMode())">
                </app-general>
                <app-abilities id="Character-abilities" class="charactersheet-app" [sheetSide]="'center'"
                    [ngClass]="{'minimized':(get_AbilitiesMinimized())}" *ngIf="!get_ShowMode()">
                </app-abilities>
                <app-health id="Character-health" class="charactersheet-app" [sheetSide]="'center'"
                    [showMinimizeButton]="(get_ShowMode() !== 'Downtime')"
                    [ngClass]="{'minimized':(get_HealthMinimized() || (get_ShowMode() === 'Downtime'))}"
                    *ngIf="get_ShowMode()==='Health'">
                </app-health>
                <app-defense id="Character-defense" class="charactersheet-app" [sheetSide]="'center'"
                    [ngClass]="{'minimized':(get_DefenseMinimized())}" *ngIf="get_ShowMode()==='Defense'">
                </app-defense>
                <app-attacks id="Character-attacks" class="charactersheet-app" [sheetSide]="'center'"
                    [ngClass]="{'minimized':(get_AttacksMinimized())}" *ngIf="get_ShowMode()==='Attacks'">
                </app-attacks>
                <app-spellbook id="spellbook" class="charactersheet-app" [sheetSide]="'center'"
                    [ngClass]="{'minimized':(get_SpellbookMinimized())}" *ngIf="get_ShowMode()==='Spells'">
                </app-spellbook>
                <app-skills id="Character-skills" class="charactersheet-app" [sheetSide]="'center'"
                    [ngClass]="{'minimized':(get_SkillsMinimized())}" *ngIf="get_ShowMode()==='Skills'">
                </app-skills>
                <app-activities id="Character-activities" class="charactersheet-app" [sheetSide]="'center'"
                    [ngClass]="{'minimized':(get_ActivitiesMinimized())}" *ngIf="get_ShowMode()==='Actions'">
                </app-activities>
                <app-inventory id="Character-inventory" class="charactersheet-app" [sheetSide]="'center'"
                    [ngClass]="{'minimized':(get_InventoryMinimized())}" *ngIf="get_ShowMode()==='Inventory'">
                </app-inventory>
            </div>
        </div>
    </ng-container>
    <!--Conditions and Effects are the same on mobile and desktop-->
    <ng-container *ngIf="(get_ShowMode() === 'ConditionsEffects')">
        <app-time class="charactersheet-app charactersheet-row" [sheetSide]="'center'"
            [ngClass]="{'minimized':(get_TimeMinimized())}"></app-time>
        <div class="charactersheet-column charactersheet-row">
            <app-effects id="Character-effects" class="charactersheet-app" [fullDisplay]="true" [sheetSide]="'center'">
            </app-effects>
        </div>
    </ng-container>
</div>
<!--Slide-in menus-->
<app-items [@slideInOut]="get_ItemsMenuState()" *ngIf="!still_loading()">
</app-items>
<app-crafting [@slideInOut]="get_CraftingMenuState()" *ngIf="!still_loading()">
</app-crafting>
<app-spells [ngClass]="{'minimized':(get_SpellsMinimized())}" [@slideInOut]="get_SpellsMenuState()"
    *ngIf="!still_loading()"></app-spells>
<app-spellLibrary [@slideInOut]="get_SpellLibraryMenuState()" *ngIf="!still_loading()"></app-spellLibrary>
<app-conditions [@slideInOut]="get_ConditionsMenuState()" *ngIf="!still_loading()"></app-conditions>
<app-character [ngClass]="{'minimized':(get_CharacterMinimized())}" [@slideInOut]="get_CharacterMenuState()"
    *ngIf="!still_loading()"></app-character>
<app-animal-companion [ngClass]="{'minimized':(get_CompanionMinimized())}" [@slideInOut]="get_CompanionMenuState()"
    *ngIf="!still_loading() && get_CompanionAvailable()">
</app-animal-companion>
<app-familiar [ngClass]="{'minimized':(get_FamiliarMinimized())}" [@slideInOut]="get_FamiliarMenuState()"
    *ngIf="!still_loading() && get_FamiliarAvailable()"></app-familiar>
<app-dice [@slideInOutVert]="get_DiceMenuState()"></app-dice>
